module.exports = __webpack_public_path__ + "img/rolling_10_express.2acd331c.png";